export default [
  {
    path: "/auth",
    name: "LogInUsers",
    meta: { name: "Вход", role: 'user' },
    component: () => import("@/views/viewLogIn/LogInUsers.vue"),
  },
  {
    path: "/auth/tsm",
    name: "LogInTSMUsers",
    meta: { name: "TSM - Вход", role: 'tsm' },
    component: () => import("@/views/viewLogIn/LogInTSM.vue"),
  },
  {
    path: "/auth/admin",
    name: "LogInAdmin",
    meta: { name: "Admin - Вход", role: 'admin' },
    component: () => import("@/views/viewLogIn/LogInAdmin.vue"),
  },
]